import React from 'react';


const Footer = () => {
    return (
        <footer className="footer text-center">
            All Rights Reserved by Reveknew Admin.
        </footer>
    );
}
export default Footer;
